// @ts-nocheck
import * as React from 'react';
import { Box, Divider, TextField, Typography, useTheme } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import {
  SecondaryButton,
  PrimaryButton,
} from 'components/__v2__/Button/ReusableButton';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

const RejectPopper = ({
  open,
  handleClose,
  setIsRejected,
  approveRejectDocument,
}) => {
  const theme = useTheme();
  const [rejectedReason, setRejectedReason] = React.useState('');

  const handleReject = () => {
    approveRejectDocument(false, rejectedReason);
    handleClose();
    setIsRejected(true);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <Box
        px={2}
        py={1}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        style={{ gap: '8px', width: 600, maxWidth: '100%' }}
      >
        <Typography variant="h6">Reject</Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: (themes) => themes.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <DialogContent px={2} py={1}>
        <Box>
          <Typography
            sx={{ color: theme.palette.normalText.dark }}
            variant="subtitle2"
          >
            Reason to reject*
          </Typography>

          <TextField
            sx={{
              '& .MuiInputBase-input': {
                color: theme.palette.primary.textColor,
              },
            }}
            variant="outlined"
            multiline
            rows={4}
            value={rejectedReason}
            onChange={(e) => setRejectedReason(e.target.value)}
          />
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Box
          height={35}
          display="flex"
          justifyContent="right"
          style={{ gap: '15px' }}
          px={2}
          my={1}
        >
          <SecondaryButton variant="outlined" onClick={handleClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton
            variant="contained"
            onClick={handleReject}
            disabled={!rejectedReason?.trim()}
          >
            Reject
          </PrimaryButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default RejectPopper;

RejectPopper.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setIsRejected: PropTypes.func.isRequired,
  approveRejectDocument: PropTypes.func.isRequired,
};
